import {get} from "lit-translate";

export type TranslateFn = (key: string, values?: Record<string, string>) => string;

/**
 * A translation, or `fallback` when there is none worth showing.
 *
 * `lit-translate`'s `get()` answers `[the.missing.key]` for a key it does not know
 * (`lit-translate/util.js`, `empty: key => \`[${key}]\``), which would put literal square
 * brackets into the UI. A value that is empty or only whitespace counts as missing too: the
 * translation editor drops empty overrides, but a single space survives saving. The result is
 * trimmed, so a tenant's "Firma XY " does not leave a gap in the tab title.
 *
 * `translate` is a seam for pure callers (page-title.helper.ts) that get the lookup handed in.
 * Pulled out of the Papierkorb dialog (feature plan 0067) instead of a fourth copy of the check.
 */
export function translateOr(
    key: string,
    fallback: string,
    values?: Record<string, string>,
    translate: TranslateFn = get,
): string {
    const value = translate(key, values).trim();
    return value === `[${key}]` || value === '' ? fallback : value;
}
